<template>
    <div class="card">
        <div class="card-header">
            <h2 class="card-title fw-bolder">{{ $t('pages.module.eTep.question.save.questionType.listen.contentArea.title') }}</h2>
        </div>
        <div class="card-body d-flex flex-column p-9">
            <div class="fv-row mb-7">
                <label class="fs-6 fw-bold mb-2">{{ $t('pages.module.eTep.question.save.questionType.listen.contentArea.cols.content') }}</label>
                <el-form-item :rules="$validation.getMessage(['required'])">
                    <CustomCkeditor :model="data.content" @updateModel="data.content = $event"></CustomCkeditor>
                </el-form-item>
            </div>
            <div class="fv-row mb-7">
                <label class="required fs-6 fw-bold mb-2">{{ $t('pages.module.eTep.question.save.questionType.listen.contentArea.cols.dragArea') }}</label>
                <el-form-item prop="track_id">
                    <el-upload :file-list="track.fileList" :accept="$root.acceptFileSupported('sound', '.')" class="upload-file" :on-change="handleChangeTrack" :on-remove="handleChangeTrack" :auto-upload="false" drag :multiple="false" :limit="1">
                        <el-icon class="el-icon--upload">
                             <span class="svg-icon">
                                 <inline-svg src="/media/icons/duotune/files/fil022.svg"/>
                             </span>
                        </el-icon>
                        <div class="el-upload__text">{{ $t('pages.module.eTep.question.save.questionType.listen.contentArea.cols.dragAreaContent') }}</div>
                    </el-upload>
                </el-form-item>
            </div>
            <div class="fv-row mb-7">
                <label class="fs-6 fw-bold mb-2">{{ $t('pages.module.eTep.question.save.questionType.listen.contentArea.cols.image') }}</label>
                <el-form-item prop="upload_id">
                    <el-upload :file-list="image.fileList" :accept="$root.acceptFileSupported('image', 'image/')" class="upload-file" :on-change="handleChangeImage" :on-remove="handleChangeImage" :auto-upload="false" drag :multiple="false" :limit="1">
                        <el-icon class="el-icon--upload">
                             <span class="svg-icon">
                                 <inline-svg src="/media/icons/duotune/files/fil022.svg"/>
                             </span>
                        </el-icon>
                        <div class="el-upload__text">{{ $t('pages.module.eTep.question.save.questionType.listen.contentArea.cols.dragAreaImageContent') }}</div>
                    </el-upload>
                </el-form-item>
            </div>
            <div class="fv-row mb-7">
                <label class="required fs-6 fw-bold mb-2">{{ $t('pages.module.eTep.question.save.questionType.listen.contentArea.cols.beforePlayWaitingSecond') }}</label>
                <el-form-item :rules="$validation.getMessage(['required'])">
                    <el-input-number v-model="data.options.before_play_waiting_second" :min="1" :max="120"/>
                </el-form-item>
            </div>
        </div>
    </div>
    <div class="card mt-7" v-if="updateStatus">
        <div class="card-header">
            <h2 class="card-title fw-bolder">{{ $t('pages.module.eTep.question.save.subQuestionType.title') }}</h2>
        </div>
        <div class="card-body">
            <div class="row" v-if="subQuestions?.length">
                <div v-for="(subQuestion, subQuestionIndex) in subQuestions" :key="subQuestionIndex">
                    <div v-if="subQuestion.sub_question_type_id === 3" :class="[(subQuestionIndex > 0 ? 'mt-md-20' : 'mt-md-0'), subQuestionIndex !== 0 && 'mt-20' ]">
                        <div class="mb-2 d-flex justify-content-between align-items-center">
                            <div class="text-gray-800 fs-4 fw-bolder">
                                {{ sprintf($t('pages.module.eTep.question.save.subQuestionType.paragraphReference.titlePattern'), [(subQuestionIndex + 1)]) }} (Paragraph Multi Choice)
                            </div>
                            <el-popconfirm :title="$t('messages.sureDelete')" :confirm-button-text="$t('btn.yes')" :cancel-button-text="$t('btn.no')" @confirm="deleteSubQuestion(subQuestion, subQuestionIndex)">
                                <template #reference>
                                    <button class="btn btn-danger btn-sm" type="button"><i class="bi bi-trash"/> Kaldır</button>
                                </template>
                            </el-popconfirm>
                        </div>
                        <div class="border border-gray-300 pt-5 px-3 pb-0 rounded">
                            <div class="fv-row mb-1">
                                <el-form-item :prop="'data.sub_questions[' + subQuestionIndex + '].data.title'" :rules="$validation.getMessage(['required'])">
                                    <CustomCkeditor :model="subQuestion.data.title" @updateModel="subQuestion.data.title = $event"></CustomCkeditor>
                                </el-form-item>

                                <div class="border border-gray-300 pt-5 px-3 pb-0 rounded bg-light-dark">

                                    <div class="mb-4 d-flex justify-content-between align-items-center">
                                        <div class="text-gray-800 fs-4 fw-bolder">
                                            {{ sprintf($t('pages.module.eTep.question.save.answer.title')) }}
                                        </div>
                                        <div class="card-toolbar">
                                            <button class="btn btn-flex btn-primary" v-on:click="addAnswer(subQuestionIndex)" type="button" :disabled="!subQuestion.id">
                                                    <span class="svg-icon svg-icon-2">
                                                        <inline-svg src="/media/icons/duotune/arrows/arr075.svg"/>
                                                    </span>
                                                {{ $t('pages.module.eTep.question.save.answer.add') }}
                                            </button>
                                        </div>
                                    </div>

                                    <div v-for="(answer, answerIndex) in subQuestion.answers" :key="answerIndex">
                                        <div class="mb-2 d-flex justify-content-between align-items-center" :class="[(answerIndex > 0) , 'border-top border-gray-300 pt-3']">
                                            <div class="text-gray-800 fs-4 fw-bolder">
                                                {{ sprintf($t('pages.module.eTep.question.save.answer.titlePattern'), [$root.questionLetters[answerIndex]]) }}
                                            </div>
                                            <el-popconfirm :title="$t('messages.sureDelete')" :confirm-button-text="$t('btn.yes')" :cancel-button-text="$t('btn.no')" @confirm="deleteAnswer(subQuestionIndex, answer, answerIndex)">
                                                <template #reference>
                                                    <button class="btn btn-danger btn-sm" type="button"><i class="bi bi-trash"/> Kaldır</button>
                                                </template>
                                            </el-popconfirm>
                                        </div>
                                        <el-form-item :prop="'data.sub_questions[' + subQuestionIndex + '].answers[' + answerIndex + '].data.content'" :rules="$validation.getMessage(['required'])">
                                            <CustomCkeditor :model="answer.data.content" @updateModel="answer.data.content = $event"></CustomCkeditor>
                                        </el-form-item>
                                        <el-form-item :rules="$validation.getMessage(['required'])">
                                            <el-input-number v-model="answer.sort" :min="1"/>
                                        </el-form-item>
                                    </div>
                                </div>

                                <div class="d-flex align-items-md-center justify-content-md-between flex-md-row flex-column mt-4">
                                    <el-tooltip
                                        class="box-item"
                                        effect="light"
                                        :content="$t('pages.module.eTep.question.save.answer.selectAnswer')"
                                        placement="top-start"
                                    >
                                        <el-form-item :rules="$validation.getMessage(['required'])">
                                            <el-select v-model="subQuestion.correct_answer" :disabled="!subQuestion.id || !subQuestion.answers?.length" :placeholder="$t('pages.module.eTep.question.save.answer.selectAnswer')">
                                                <el-option
                                                    v-for="(answer, answerIndex) in subQuestion.answers.filter(a => a.id)"
                                                    :key="answerIndex"
                                                    :value="String(answer.id)"
                                                    :label="sprintf($t('pages.module.eTep.question.save.answer.titlePattern'), [$root.questionLetters[answerIndex]])"
                                                >
                                                    {{ sprintf($t('pages.module.eTep.question.save.answer.titlePattern'), [$root.questionLetters[answerIndex]]) }}
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-tooltip>
                                    <el-form-item :rules="$validation.getMessage(['required'])">
                                        <el-input-number v-model="subQuestion.sort" :min="1"/>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="d-flex flex-column align-items-center justify-content-center py-5">
                <p class="text-gray-600 text-center">{{ $t('pages.module.eTep.question.save.subQuestionType.subQuestionAddContent') }}</p>
                <div class="d-flex flex-column flex-md-row align-items-center justify-content-center">
                    <button class="btn btn-flex btn-primary me-2" v-for="(type, typeIndex) in subQuestionTypes" :key="typeIndex" v-on:click="addSubQuestion(type.id)" type="button">
                        <span class="svg-icon svg-icon-2">
                            <inline-svg src="/media/icons/duotune/arrows/arr075.svg"/>
                        </span>
                        {{ $t('pages.module.eTep.question.save.subQuestionType.code.' + type.code) }}
                    </button>
                </div>
            </div>
        </div>
        <div class="card-footer" v-if="subQuestions?.length">
            <button class="btn btn-flex btn-primary me-2" v-for="(type, typeIndex) in subQuestionTypes" :key="typeIndex" v-on:click="addSubQuestion(type.id)" type="button">
                <span class="svg-icon svg-icon-2">
                    <inline-svg src="/media/icons/duotune/arrows/arr075.svg"/>
                </span>
                {{ $t('pages.module.eTep.question.save.subQuestionType.code.' + type.code) }}
            </button>
        </div>
    </div>
</template>

<script>
import CustomCkeditor from "@/components/custom-ckeditor/index.vue";
import md5 from 'md5'

export default {
    name: "Paragraph",
    props: {
        data: Object,
        subQuestionTypes: Array,
        subQuestions: Array,
        updateStatus: Boolean,
        image: Object,
        track: Object,
    },
    data() {
        return {
            paragraphPreview: true,
        }
    },
    components: {
        CustomCkeditor
    },
    methods: {
        addSubQuestion(typeId) {
            let subQuestionLength = this.subQuestions.length;
            this.subQuestions.push({
                id: false,
                sub_question_type_id: typeId,
                data: {
                    title: '',
                },
                answers: [],
                sort: this.subQuestions.length !== 0 ? (this.subQuestions[subQuestionLength - 1].sort + 1) : 1,
            })
        },
        deleteSubQuestion(value, index) {
            if (value.id) {
                this.$store.dispatch("module/etep/question/sub/delete", {
                    id: [value.id]
                }).then((successDeleted) => {
                    if (successDeleted) {
                        this.$emit('load-question', true)
                    }
                });
            } else {
                this.subQuestions.splice(index, 1);
            }
        },
        addAnswer(index) {
            let subQuestionLength = this.subQuestions[index].answers.length;
            this.subQuestions[index].answers.push({
                data: {
                    content: ''
                },
                sort: subQuestionLength !== 0 ? (this.subQuestions[index].answers[subQuestionLength - 1].sort + 1) : 1,
            })
        },
        deleteAnswer(indexSubQuest, value, index) {
            if (value.id) {
                this.$store.dispatch("module/etep/question/answer/delete", {
                    id: [value.id]
                }).then((successDeleted) => {
                    if (successDeleted) {
                        this.$emit('load-question', true)
                    }
                });
            } else {
                this.subQuestions[indexSubQuest].answers.splice(index, 1);
            }
        },
        handlePictureCardPreview(file) {
            this.image.dialogImageUrl = file.url
            this.image.dialogVisible = true
        },
        handleChangeImage(file, fileList) {
            this.image.fileList = fileList;
            this.image.uploadList = fileList;
        },
        handleChangeTrack(file, fileList) {
            this.track.fileList = fileList;
            this.track.uploadList = fileList;
        }
    }
};
</script>
